export const STATUS_CLASS = {
  "Pending": "badge-status badge-status-pending",
  "Drafting Pending": "badge-status badge-status-pending",
  "Ready for Drafting": "badge-status badge-status-pending",
  "Processing": "badge-status badge-status-processing",
  "Running": "badge-status badge-status-processing",
  "Generated": "badge-status badge-status-processing",
  "Completed": "badge-status badge-status-completed",
  "Approved": "badge-status badge-status-approved",
  "Finalized": "badge-status badge-status-approved",
  "Failed": "badge-status badge-status-failed",
  "Open": "badge-status badge-status-failed",
  "In Review": "badge-status badge-status-review",
  "Pending Officer Approval": "badge-status badge-status-review",
  "Pending Approval": "badge-status badge-status-review",
  "Returned": "badge-status badge-status-returned",
  "Returned for Correction": "badge-status badge-status-returned",
  "Edited": "badge-status badge-status-review",
  "Active": "badge-status badge-status-completed",
};

export default function StatusBadge({ status, className = "", ...rest }) {
  const cls = STATUS_CLASS[status] || "badge-status badge-status-default";
  return (
    <span className={`${cls} ${className}`} data-testid="status-badge" {...rest}>
      {status || "—"}
    </span>
  );
}
